__webpack_require__.p = "https://static.age.awaze.com/search-mfe/5a4d8ba/_next/";